export default __webpack_public_path__ + "static/media/financial_summary.6cc20dd6.svg";